// The two-tier arrangement control — a ranking-rule row over a filter-chip
// row. Extracted from RelationTree (owner-directed session, 2026-07-31) so the
// tree and the viewset surfaces share one control: the same primitive the
// project ruled at both levels ("every view is a viewset + a ranking rule").
//
// Deliberately dumb: no fetching, no arrangement logic (that lives in
// treeArrange.js), no knowledge of what the chips MEAN. The tree passes
// relation names colored by relationColor; a viewset passes tag values. The
// markup and classes are exactly the tree's original control bar, so the
// extraction is render-identical there.
//
// filterItems: [{ key, label, count, on, color, disabled, disabledHint }]
//   - `disabled` exists for the viewset case: chips are VIEW-TIME NARROWING,
//     and the last live member of an OR-group must not be removable (dropping
//     it would erase the group's AND-constraint and WIDEN the view — the
//     opposite of what a filter chip promises).

export default function ArrangeBar({
  sorts,
  sort,
  onSort,
  sortAria = 'ranking rule',
  filterItems,
  onToggleFilter,
  filterAria = 'filter',
}) {
  return (
    <div className="wvt-controls">
      <div className="wvt-sortrow" role="group" aria-label={sortAria}>
        {sorts.map((s) => (
          <button
            key={s.key}
            className={`wvt-sort${sort === s.key ? ' wvt-sort-on' : ''}`}
            onClick={() => onSort(s.key)}
            title={s.hint}
            aria-pressed={sort === s.key}
          >
            {s.label}
          </button>
        ))}
      </div>
      {filterItems && filterItems.length > 1 && (
        <div className="wvt-chiprow" role="group" aria-label={filterAria}>
          {filterItems.map((item) => (
            <button
              key={item.key}
              className={`wvt-chip${item.on ? ' wvt-chip-on' : ''}`}
              onClick={() => !item.disabled && onToggleFilter(item.key)}
              aria-pressed={item.on}
              disabled={item.disabled}
              title={
                item.disabled
                  ? item.disabledHint
                  : item.on
                  ? `hide ${item.label}`
                  : `show ${item.label}`
              }
              style={item.on && item.color ? { color: item.color, borderColor: item.color } : undefined}
            >
              {item.label}{' '}
              {typeof item.count === 'number' && (
                <span className="trust-muted" style={{ fontWeight: 'normal' }}>{item.count}</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
